<template>
  <DashboardPanel title="房屋数据">
    <div class="room-data">
      <div ref="chart" class="room-chart"></div>
      <ul class="room-legend">
        <li v-for="item in rooms" :key="item.name"><i :style="{ background: item.color }"></i><span>{{ item.name }}</span><strong>{{ format(item.value) }}<small>户</small></strong><em>{{ item.percent }}</em></li>
      </ul>
      <div class="room-metrics">
        <div v-for="item in metrics" :key="item.label"><i :class="item.icon" :style="{ color: item.color }"></i><p><span>{{ item.label }}</span><strong :style="{ color: item.color }">{{ item.value }}</strong></p></div>
      </div>
    </div>
  </DashboardPanel>
</template>

<script>
import * as echarts from 'echarts'
import DashboardPanel from './DashboardPanel.vue'
import { dashboardTooltip, formatNumber, formatPercent, toNumber } from '../dashboardFormat'
export default {
  name: 'RoomData',
  components: { DashboardPanel },
  props: { data: { type: Object, default: () => ({}) } },
  data: () => ({ chart: null }),
  computed: {
    rooms() {
      const rows = Array.isArray(this.data.breakdown) ? this.data.breakdown : []
      const grouped = rows.reduce((result, row) => {
        const key = row.roomState || 'unknown'
        const current = result[key] || { name: row.roomStateName || `状态 ${key}`, value: 0 }
        current.value += toNumber(row.roomCount)
        if (row.roomStateName) current.name = row.roomStateName
        result[key] = current
        return result
      }, {})
      const total = toNumber((this.data.summary || {}).totalRooms)
      const colors = ['#2d87f4', '#32bdca', '#f7a344', '#8667df', '#4ec478', '#9b75e8']
      return Object.keys(grouped).map((key, index) => {
        const item = grouped[key]
        return Object.assign(item, {
          percent: formatPercent(item.value, total),
          color: colors[index % colors.length]
        })
      }).sort((a, b) => b.value - a.value).slice(0, 5)
    },
    metrics() {
      const summary = this.data.summary || {}
      const total = toNumber(summary.totalRooms)
      const bound = toNumber(summary.boundRooms)
      const unbound = toNumber(summary.unboundRooms)
      return [
        { label: '已绑定率', value: formatPercent(bound, total), icon: 'el-icon-house', color: '#2d87f4' },
        { label: '未绑定率', value: formatPercent(unbound, total), icon: 'el-icon-house', color: '#35c66a' },
        { label: '住宅数', value: `${this.format(summary.residentialRooms)} 户`, icon: 'el-icon-place', color: '#2d87f4' },
        { label: '非住宅数', value: `${this.format(summary.nonResidentialRooms)} 户`, icon: 'el-icon-document', color: '#2d87f4' }
      ]
    }
  },
  watch: { data: { deep: true, handler() { this.renderChart() } } },
  mounted() { this.renderChart(); window.addEventListener('resize', this.resizeChart) },
  beforeDestroy() { window.removeEventListener('resize', this.resizeChart); if (this.chart) this.chart.dispose() },
  methods: {
    renderChart() {
      if (!this.chart) this.chart = echarts.init(this.$refs.chart)
      const total = toNumber((this.data.summary || {}).totalRooms)
      this.chart.setOption({
        color: this.rooms.map(item => item.color),
        tooltip: dashboardTooltip({
          trigger: 'item',
          formatter: params => `${params.marker}${echarts.format.encodeHTML(params.name)}<br/>房屋数：${formatNumber(params.value)} 户<br/>占比：${formatPercent(params.value, total)}`
        }),
        series: [{ type: 'pie', radius: ['48%', '76%'], center: ['50%', '50%'], startAngle: 90, clockwise: true, avoidLabelOverlap: false, label: { show: false }, data: this.rooms.map(item => ({ value: item.value, name: item.name })) }],
        graphic: [{ type: 'text', left: 'center', top: '42%', style: { text: this.format(total), fill: '#ecf6ff', fontSize: 18, fontWeight: 700, textAlign: 'center' } }, { type: 'text', left: 'center', top: '54%', style: { text: '房屋总数', fill: '#91a8ba', fontSize: 10, textAlign: 'center' } }]
      })
    },
    resizeChart() { if (this.chart) this.chart.resize() },
    format(value) { return formatNumber(value) }
  }
}
</script>

<style lang="scss" scoped>
.room-data { display: grid; grid-template-columns: 138px 1fr 145px; align-items: center; height: 100%; padding: 0 10px 8px; }
.room-chart { width: 132px; height: 152px; }
.room-legend { margin: 0; padding: 0 10px 0 2px; list-style: none; }
.room-legend li { display: grid; grid-template-columns: 7px 48px 1fr 44px; align-items: center; height: 31px; color: #b8cad8; font-size: 12px; white-space: nowrap; }
.room-legend i { width: 7px; height: 7px; border-radius: 50%; }
.room-legend strong { color: #eef6fc; font-size: 13px; text-align: right; }
.room-legend small { margin-left: 2px; font-size: 9px; font-weight: 400; }
.room-legend em { color: #879baa; font-size: 11px; font-style: normal; text-align: right; }
.room-metrics { height: 100%; padding-left: 11px; border-left: 1px solid rgba(69, 125, 163, .36); }
.room-metrics > div { display: flex; align-items: center; height: 25%; border-bottom: 1px solid rgba(63, 120, 159, .2); }
.room-metrics > div:last-child { border-bottom: 0; }
.room-metrics i { width: 34px; font-size: 25px; }
.room-metrics p { margin: 0; }
.room-metrics span { display: block; color: #c2d1dd; font-size: 12px; }
.room-metrics strong { display: block; margin-top: 2px; font-size: 18px; line-height: 1; }
</style>
